import { render, staticRenderFns } from "./RegisterCompanyDataStep.vue?vue&type=template&id=d580210c&scoped=true"
import script from "./RegisterCompanyDataStep.vue?vue&type=script&lang=js"
export * from "./RegisterCompanyDataStep.vue?vue&type=script&lang=js"
import style0 from "./RegisterCompanyDataStep.vue?vue&type=style&index=0&id=d580210c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d580210c",
  null
  
)

export default component.exports